import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { fuseAnimations } from '@fuse/animations';
import { QueryLog } from 'app/models/quey-log.model';
import { User } from 'app/models/user.model';
import { LogsService } from 'app/services/logs.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'query-log',
    templateUrl: './query-log.component.html',
    styleUrls: ['./query-log.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class QueryLogComponent implements OnInit {


    @ViewChild(MatSort) private _sort: MatSort;
    @ViewChild(MatPaginator) private _paginator: MatPaginator;

    public pageLenght:number;
    private _queryList: Array<QueryLog> = [];
    public get queryList(): Array<QueryLog> {
        return this._queryList;
    }
    private _filterText: string = '';
    public get filterText(): string {
        return this._filterText;
    }
    public set filterText(v: string) {
        this._filterText = v.trim().toLowerCase();
        this._dataSource.filter = this._filterText;
    }
    private _dataSource: MatTableDataSource<QueryLog> = undefined;
    public get dataSource(): MatTableDataSource<QueryLog> {
        return this._dataSource;
    }

    private _displayedColumns = ['getValue', 'type', 'date'];

    public get displayedColumns(): Array<string> {
        return this._displayedColumns;
    }

    constructor(private _logsService: LogsService,private _spinner: NgxSpinnerService) {
    }

    public async ngOnInit() {
        await this.pageCount();
        await this.getQueryList();
    }
    private async getQueryList(): Promise<Array<QueryLog>> {
        try {
            this._spinner.show('loading')            
            this._queryList = await this._logsService.getQuery(parseInt(localStorage.getItem("CompanyID")),this._paginator.pageIndex,this._paginator.pageSize);
            this._spinner.hide('loading')
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);
            return [];
        }
        this.updateTableDataSource();

    }
    public async pageCount(){
        try {            
            this.pageLenght = await this._logsService.getQueryCount(parseInt(localStorage.getItem("CompanyID")));
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);
        }
    }
    /**
     * pageEvent
     */
    public async pageEvent(e) {
        try {
            this._spinner.show('loading')
            this._queryList = await this._logsService.getQuery(parseInt(localStorage.getItem("CompanyID")),e.pageIndex,e.pageSize);
            this._spinner.hide('loading')
            
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);
            return [];
        }
        this.updateTableDataSource();        
    }

    private async updateTableDataSource(): Promise<void> {
        this._dataSource = new MatTableDataSource<QueryLog>(this._queryList);
        this._dataSource.sort = this._sort;
    }

}
